import type { RoundPhase, Team, TeamType } from '@shared-types/match.types';
import { loadFromAPIs, recursiveCall } from '@utilities/fetch';
import { apiKey, compApiUrl, domesticApiUrl } from '@utilities/WindowContext';

export function fetchAllTeams(
  params: {
    competitionId: string;
    seasonYear: string;
    phase?: RoundPhase | 'ALL';
    isDomestic?: boolean;
    limit?: number;
  },
  signal?: AbortSignal,
) {
  const { competitionId, seasonYear, phase, isDomestic, limit } = params;
  if (isDomestic) {
    return loadFromAPIs<Team[]>(`/v2/competitions/${competitionId}/seasons/${seasonYear}/teams`, null, {
      apiKey,
      apiUrl: domesticApiUrl,
      signal,
    });
  }

  return recursiveCall<Team>(
    'v2/teams',
    {
      competitionId,
      seasonYear,
      phase,
      limit,
    },
    { apiKey, apiUrl: compApiUrl, signal },
  );
}

export const fetchTeamsById = (teamIds: string[], signal?: AbortSignal) =>
  loadFromAPIs<Team[]>(
    'v2/teams',
    {
      teamIds,
    },
    {
      apiKey,
      apiUrl: compApiUrl,
      signal,
    },
  );

export const fetchAssociationTeams = (
  params: {
    associationId: string;
    phase?: RoundPhase | 'ALL';
    teamType?: TeamType;
    limit?: number;
    offset?: number;
  },
  signal?: AbortSignal,
) => recursiveCall<Team>('v2/teams', params, { apiKey, apiUrl: compApiUrl, signal });

export const fetchTeamsByPlayerId = (
  params: { competitionId: string; seasonYear: string; playerId: string[] },
  signal?: AbortSignal,
) =>
  loadFromAPIs<{ playerId: string; teamId: string }[]>('v2/team-players', params, {
    apiKey,
    apiUrl: compApiUrl,
    signal,
  });
